import { graphql, useStaticQuery } from 'gatsby';

export const useGetGatsbyImages = () => {
  const images = useStaticQuery(graphql`
    query GetImageQuery {
      allFile(filter: { sourceInstanceName: { eq: "images" } }) {
        nodes {
          childImageSharp {
            gatsbyImageData(breakpoints: [320, 479, 768, 1280, 1920], quality: 80, layout: FULL_WIDTH)
          }
          publicURL
          relativePath
        }
      }
    }
  `);

  return images;
};
